import axiosInstance from '../auth/axiosInstance';

export const getBusinessTypeList = async (page, pageSize, sort = 'name-asc', search = '') => {
  try {
    console.log('Fetching business type list...');
    const { data: result } = await axiosInstance.get('/Project/GetBusinessTypeList', {
      params: { pageNumber: page, pageSize, sort, search },
    });

    if (
      result.data &&
      Array.isArray(result.data.items) &&
      typeof result.data.totalCount === 'number'
    ) {
      const { items, totalCount, pageNumber, pageSize: returnedSize } = result.data;
      return { items, totalCount, pageNumber, pageSize: returnedSize };
    }

    console.error('Unexpected response structure:', result);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  } catch (error) {
    console.error('Error fetching companies:', error);
    return { items: [], totalCount: 0, pageNumber: page, pageSize };
  }
};

export const addOrUpdateBusinessType = async (businessData) => {
  try {
    console.log('Adding/updating business with data:', businessData);

    const formattedData = {
      ...businessData,
      isActive: businessData.isActive ? true : false,
    };

    console.log('Formatted data being sent to API:', formattedData);

    const { data: responseData } = await axiosInstance.post(
      '/Project/AddOrUpdateBusinessType',
      formattedData
    );

    console.log('AddOrUpdateBusinessType response:', responseData);

    if (responseData.data) return responseData.data;

    console.error('Invalid response structure:', responseData);
    return { ...formattedData, id: formattedData.id || `temp-${Date.now()}` };
  } catch (error) {
    console.error('Error during saving business:', error.message || error);
    throw error;
  }
};

export const deleteBusinessType = async (businessId) => {
  try {
    console.log('Deleting business with ID:', businessId);
    const { data: responseData, status } = await axiosInstance.post(
      `/Project/DeleteBusinessType/${businessId}`
    );

    if (status !== 204) {
      console.log('Delete business response:', responseData);
      return responseData;
    }
    console.log('business deleted successfully');
  } catch (error) {
    console.error('Error during deleting business:', error.message || error);
    throw error;
  }
};
